import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react'
import { AppContainer } from 'components/ui/appContainer'
import { CustomHeading } from 'components/ui/customHeading'
import { useResetPasswordMutation } from 'generated/graphql'
import { useCustomToast } from 'hooks/useCustomToast'
import { buildErrorMessage } from 'lib/errorHandler/buildErrorMessage'
import { processError } from 'lib/errorHandler/processError'
import { useRouter } from 'next/router'
import { FC, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { MdPerson } from 'react-icons/md'
import { Routes } from 'routes'

type FormInput = {
  email: string
}

export const ResetPasswordPage: FC = () => {
  const toast = useCustomToast()
  const router = useRouter()
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormInput>()
  const [resetPassword, { loading: submitting }] = useResetPasswordMutation()

  const onSubmit = useCallback(async (input: FormInput) => {
    const res = await resetPassword({ variables: { email: input.email } })
    if (res.errors) {
      toast('error', buildErrorMessage(processError(res.errors)))
      return
    }

    router.push(Routes.resetPasswordSent())
  }, [])

  return (
    <AppContainer>
      <Box pt={20} pb={44}>
        <Flex justify="space-between">
          <Box>
            <CustomHeading as="h2">パスワードを忘れた場合</CustomHeading>
            <Text lineHeight={'22px'} mt={10}>
              パスワードを紛失した場合は、こちらより登録メールアドレスをご入力ください。
              <br />
              パスワードの再設定URLを登録されているメールアドレスに送信いたします。
            </Text>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Flex direction="column" mt={16}>
                <Flex alignItems="flex-end">
                  <FormControl isInvalid={!!errors.email} w="346px">
                    <FormLabel>登録メールアドレス</FormLabel>
                    <InputGroup>
                      {/* eslint-disable-next-line react/no-children-prop */}
                      <InputLeftElement children={<Icon as={MdPerson} w={6} h={6} color="blue.600" />} />
                      <Input {...register('email', { required: '必須です' })} placeholder="example@example.co.jp" />
                    </InputGroup>
                    <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
                  </FormControl>
                  <Button type="submit" isLoading={submitting} ml={10}>
                    パスワードをリセット
                  </Button>
                </Flex>
              </Flex>
            </form>
          </Box>

          <Image src="/assets/pages/reset-password/main.svg" w="400px" h="320px" />
        </Flex>

        <Text fontSize={14} lineHeight={'24px'} mt={'92px'}>
          ※メールが届かない場合は..
          <br />
          ・noreply@hoteco-wcc.comからのメールが迷惑メールフォルダに届いていないかご確認ください。
          <br />
          ・登録メールアドレスがご不明なお客様は、HoteCoカスタマーデスク（contact@support.hoteco-wcc.com）へメールにてご連絡ください。
        </Text>
      </Box>
    </AppContainer>
  )
}
